<template>
  <component
    :is="card ? 'q-card' : 'q-item'"
    :style="{
      'background': backgroundColor || paymentMethodBrandsBgColor(defaultPaymentMethodBrand),
      'max-width': card ? '400px' : undefined,
      'min-height': card ? '230px' : undefined,
    }"
  >
    <slot name="prepend" />
    <component
      :is="card ? 'q-card-section' : 'q-item-section'"
      :side="!card"
      :class="card ? 'text-right' : undefined"
    >
      <q-icon
        :style="{
          color: paymentMethodBrandsColor(defaultPaymentMethodBrand),
          'background-color': paymentMethodBrandsIconBgColor(defaultPaymentMethodBrand)
        }"
        :name="paymentMethodBrandsIcon(defaultPaymentMethodBrand)"
        :size="card ? 'lg' : 'xs'"
      />
    </component>
    <component
      :is="card ? 'q-card-section' : 'q-item-section'"
      class="text-left"
      :class="{
        'q-mt-md': card,
        'text-black': !backgroundColor
      }"
    >
      <div
        v-if="card"
        class="text-body1"
        :style="{
          color: paymentMethodBrandsColor(defaultPaymentMethodBrand),
          'text-shadow': card ? '0 0 1px rgba(0, 0, 0, 0.1)' : undefined
        }"
      >
        {{ $_.startCase(defaultPaymentMethodBrand) }}
      </div>
      <component
        :is="card ? 'div' : 'q-item-label'"
        class="text-bold"
        :class="{
          'text-white': isSelected && $q.dark.isActive,
          'text-primary': isSelected && !$q.dark.isActive,
          'text-body1': card,
          'text-body2': !card
        }"
        :style="{
          color: !isSelected ? textColor || paymentMethodBrandsColor(defaultPaymentMethodBrand) : undefined,
          'text-shadow': card ? '0 0 1px rgba(0, 0, 0, 0.1)' : undefined
        }"
      >
        <slot name="prompt" />
        <template v-if="card">
          <span class="q-pr-md">* * * *</span>
          <span class="q-pr-md">* * * *</span>
          <span class="q-pr-md">* * * *</span>
        </template>
        <template v-else>
          {{ $_.startCase(defaultPaymentMethodBrand) }} {{ $t('payment.ending') }}
        </template>
        {{ defaultPaymentMethodLast4 }}
      </component>
      <slot name="message" />
    </component>
    <slot name="action" />
  </component>
</template>
<script>
import { PAYMENT_CARD_PROVIDER } from 'src/models/payment/Payment'

const PAYMENT_CARD_PROVIDER_COLOR = {
  VISA: '#1434cb',
  MASTERCARD: '#EB001B',
  AMEX: '#006fcf',
  DISCOVER: '#ec6b29',
  JCB: '#008eed',
  DINERS: 'diners-club',
  DEFAULT: '#dfe4ea'
}
export default {
  name: 'DefaultPaymentMethodBrand',
  props: {
    card: {
      type: Boolean,
      required: false,
      default: false
    },
    defaultPaymentMethodBrand: {
      type: String,
      required: true,
      default: null
    },
    defaultPaymentMethodLast4: {
      type: String,
      required: true,
      default: null
    },
    backgroundColor: {
      type: String,
      required: false,
      default: null
    },
    textColor: {
      type: String,
      required: false,
      default: null
    },
    isSelected: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  created () {
    _.extend(this, { PAYMENT_CARD_PROVIDER })
  },
  methods: {
    paymentMethodBrandsBgColor (cardType) {
      if (this.card) return PAYMENT_CARD_PROVIDER_COLOR.DEFAULT
      if (cardType === PAYMENT_CARD_PROVIDER.VISA) {
        return this.$lightenColor(PAYMENT_CARD_PROVIDER_COLOR.VISA, 90)
      } else if (cardType === PAYMENT_CARD_PROVIDER.MASTERCARD) {
        return this.$lightenColor(PAYMENT_CARD_PROVIDER_COLOR.MASTERCARD, 60)
      } else if (cardType === PAYMENT_CARD_PROVIDER.AMEX) {
        return this.$lightenColor(PAYMENT_CARD_PROVIDER_COLOR.AMEX, 90)
      } else if (cardType === PAYMENT_CARD_PROVIDER.DISCOVER) {
        return this.$lightenColor(PAYMENT_CARD_PROVIDER_COLOR.DISCOVER, 90)
      } else {
        return this.$lightenColor('black', 90)
      }
    },
    paymentMethodBrandsColor (cardType) {
      if (cardType === PAYMENT_CARD_PROVIDER.VISA) {
        return this.backgroundColor && this.$isColorDark(this.backgroundColor) ? 'white' : PAYMENT_CARD_PROVIDER_COLOR.VISA
      } else if (cardType === PAYMENT_CARD_PROVIDER.MASTERCARD) {
        return PAYMENT_CARD_PROVIDER_COLOR.MASTER
      } else if (cardType === PAYMENT_CARD_PROVIDER.AMEX) {
        return PAYMENT_CARD_PROVIDER_COLOR.AMEX
      } else if (cardType === PAYMENT_CARD_PROVIDER.DISCOVER) {
        return PAYMENT_CARD_PROVIDER_COLOR.DISCOVER
      } else {
        return this.backgroundColor ? this.$isColorDark(this.backgroundColor) ? 'white' : 'black' : undefined
      }
    },
    paymentMethodBrandsIconBgColor (cardType) {
      if (cardType === PAYMENT_CARD_PROVIDER.VISA && this.backgroundColor && this.$isColorDark(this.backgroundColor)) {
        return PAYMENT_CARD_PROVIDER_COLOR.VISA
      }
      return undefined
    },
    paymentMethodBrandsIcon (cardType) {
      const cardTypes = PAYMENT_CARD_PROVIDER
      if (_.includes(cardTypes, cardType)) {
        return `fab fa-cc-${cardType}`
      }
      return 'fal fa-credit-card'
    }
  }
}
</script>
